import { S142gS142m01Component } from './s142g-s142m01.component';

export { S142gModule } from './s142g.module';

export const S142gSubComponentsMap = {
	
};

export const S142gComponentsMap = {
	"s142g-s142m01": S142gS142m01Component
};

export const S142gComponents = [
	S142gS142m01Component
];

